import { Navigate } from 'react-router';
import { usePermissions } from '@/hooks/usePermissions';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Route guard that restricts access to root admin roles only (Owner, Admin, Super Admin).
 * Matches scio1's `principal.isRootAdmin()` check.
 * Used for Analytics routes (Proof of Play, AI Analytics).
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const me = useAuthStore((s) => s.me);
  const { isRootAdmin } = usePermissions();

  // While user data is loading, don't flash redirect
  if (!me) return null;

  if (!isRootAdmin) {
    return <Navigate to="/app/screenManagement" replace />;
  }

  return <>{children}</>;
}
